import { User } from 'src/app/shared/user.model';

export class CompanyCreditInfo {
    CreditDate: Date;
    ForiusID: string;
    EntityID: string;
    FileReturnedFromForius: boolean;
    ScoreExists: boolean;
    Special: string;
    TradeLineCount: number;
    YearsInFile: number;
    URLCourtesyLink: string;
    ShowCourtesyLink: boolean;
    CourtesyLinkText: string;
    CreditScanText: string;
    CreditProfileText: string;
    IntelliscoreText: string;
    BusinessProfileText: string;
    ComboText: string;
    CreditProfileRate: string;
    CreditScanRate: string;
    ExperianIntelliscoreRate: string;
    ExperianBusinessProfileRate: string;
    ExperianBPRScoreComboRate: string;
    CreditAvailable: boolean = false;
    IsAuthorized: boolean = false;
    RequestedId: string;
    constructor(
        CreditDate: Date,
        ForiusID: string,
        EntityId: string,
        FileReturnedFromForius: boolean,
        ScoreExists: boolean,
        Special: string,
        TradeLineCount: number,
        YearsInFile: number,
        IsAuthorized: boolean,
        RequestedId: string,
        CreditProfileRate: string,
        CreditScanRate: string,
        ExperianIntelliscoreRate: string,
        ExperianBusinessProfileRate: string,
        ExperianBPRScoreComboRate: string
    ) {
        this.CreditDate = CreditDate;
        this.ForiusID = ForiusID;
        this.FileReturnedFromForius = FileReturnedFromForius;
        this.ScoreExists = ScoreExists;
        this.Special = Special;
        this.TradeLineCount = TradeLineCount;
        this.YearsInFile = YearsInFile;
        this.RequestedId = RequestedId;
        this.IsAuthorized = IsAuthorized;
        this.CreditProfileRate = CreditProfileRate;
        this.CreditScanRate = CreditScanRate;
        this.ExperianIntelliscoreRate = ExperianIntelliscoreRate;
        this.ExperianBusinessProfileRate = ExperianBusinessProfileRate;
        this.ExperianBPRScoreComboRate = ExperianBPRScoreComboRate;
        this.RequestedId = EntityId;

        this.setUpLinks();
    }
    setUpLinks(){
        if (!this.IsAuthorized) return;
        if (this.Special != null && this.Special.toUpperCase() === "GTCYDP"){
            this.ShowCourtesyLink = true;
            this.CourtesyLinkText = "Check My PPAI Credit Profile<br /><strong>FREE for PPAI Members ($18 Value)</strong>";
        }
        if (this.ForiusID != null && this.ForiusID.length > 0){
            this.CreditAvailable = true;
        }
    }
    getFormattedDateOfCreditInfo() {
        if (new Date(this.CreditDate) < new Date(1990,1)){
            return "NA";
        }
        let d = new Date(this.CreditDate);
        return (d.getMonth()+1) + '/' + d.getDate() + '/' + d.getFullYear();
    }
    getFormattedTradeLineCount() {
        if (this.TradeLineCount == null || this.TradeLineCount < 0) return "NA";
        return this.TradeLineCount;
    }
    getFormattedYearsInFile() {
        if (this.YearsInFile == null || this.YearsInFile < 0) return "NA";
        return this.YearsInFile;
    }
    getFormattedScoreExists() {
        if (this.ScoreExists != null && this.ScoreExists) return "Exists";
        return "None";
    }
    getFormattedExperianFileNumber() {
        if (this.ForiusID != null && this.ForiusID.length <= 0) return "NA";
        return this.ForiusID;
    }
    hasFreeReport() {
        return this.Special != null && this.Special.toUpperCase() == "GTCYDP";
    }
}